/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applications_Status_WithdrawnInputs */

const en_applications_status_withdrawn = /** @type {(inputs: Applications_Status_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdrawn`)
};

const de_applications_status_withdrawn = /** @type {(inputs: Applications_Status_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurückgezogen`)
};

const fr_applications_status_withdrawn = /** @type {(inputs: Applications_Status_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retiré`)
};

const es_applications_status_withdrawn = /** @type {(inputs: Applications_Status_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirado`)
};

const it_applications_status_withdrawn = /** @type {(inputs: Applications_Status_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritirata`)
};

const nl_applications_status_withdrawn = /** @type {(inputs: Applications_Status_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teruggetrokken`)
};

const pl_applications_status_withdrawn = /** @type {(inputs: Applications_Status_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wycofano`)
};

const fi_applications_status_withdrawn = /** @type {(inputs: Applications_Status_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peruttu`)
};

const da_applications_status_withdrawn = /** @type {(inputs: Applications_Status_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trukket tilbage`)
};

const sv_applications_status_withdrawn = /** @type {(inputs: Applications_Status_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Återkallad`)
};

/**
* | output |
* | --- |
* | "Withdrawn" |
*
* @param {Applications_Status_WithdrawnInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_status_withdrawn = /** @type {((inputs?: Applications_Status_WithdrawnInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Status_WithdrawnInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_status_withdrawn(inputs)
	if (locale === "fr") return fr_applications_status_withdrawn(inputs)
	if (locale === "es") return es_applications_status_withdrawn(inputs)
	if (locale === "it") return it_applications_status_withdrawn(inputs)
	if (locale === "nl") return nl_applications_status_withdrawn(inputs)
	if (locale === "pl") return pl_applications_status_withdrawn(inputs)
	if (locale === "fi") return fi_applications_status_withdrawn(inputs)
	if (locale === "da") return da_applications_status_withdrawn(inputs)
	if (locale === "sv") return sv_applications_status_withdrawn(inputs)
	return en_applications_status_withdrawn(inputs)
});